/* A barra do exemplo: os números de referência da prévia.
 * Campo areia, contexto que não opina; nenhum número daqui é salvo. */

import { Celula } from '@/componentes/celula';
import { Input } from '@/componentes/ui/input';

export function BarraExemplo({
  modulos,
  kwp,
  aoMudarModulos,
  aoMudarKwp,
}: {
  modulos: string;
  kwp: string;
  aoMudarModulos: (valor: string) => void;
  aoMudarKwp: (valor: string) => void;
}) {
  return (
    <Celula campo="areia" respiro="justo" className="flex flex-wrap items-center gap-2 text-apoio">
      <span>Calcular exemplo para</span>
      <Input
        type="number"
        min={1}
        step={1}
        value={modulos}
        onChange={(evento) => aoMudarModulos(evento.currentTarget.value)}
        aria-label="Quantidade de módulos do exemplo"
        className="numero h-8 w-20 bg-card text-center"
      />
      <strong className="font-semibold">módulos</strong>
      <span>e</span>
      <Input
        type="number"
        min={0.1}
        step={0.1}
        value={kwp}
        onChange={(evento) => aoMudarKwp(evento.currentTarget.value)}
        aria-label="Potência em kWp do exemplo"
        className="numero h-8 w-24 bg-card text-center"
      />
      <strong className="font-semibold">kWp</strong>
      <span className="text-tinta-2 text-nota mesa:ml-auto">
        O exemplo não é salvo. Serve para conferir as regras.
      </span>
    </Celula>
  );
}

/** Referência inválida devolve `null`: a prévia some, o campo nunca é reescrito. */
export function referencia(texto: string): number | null {
  const n = parseFloat(texto);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/* Coluna `numeric` do Postgres, já convertida na borda do banco. Nada de
 * parseNum aqui: o parser pt-BR leria "1.500" como mil e quinhentos. */
export function numeroDaLinha(valor: number | string | null | undefined): number {
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
  if (typeof valor !== 'string' || valor.trim() === '') return 0;
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
}
